import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
/**
 * Converts a string with new lines to a string with <br /> tags
 * without dangerouslySetInnerHTML
 * @param text string with new lines (\n)
 */ export function replaceNewLinesWithBreaks(text) {
    return text.split("\n").map((text, index, lines)=>/*#__PURE__*/ _jsxs(React.Fragment, {
            children: [
                text,
                index !== lines.length - 1 && /*#__PURE__*/ _jsx("br", {})
            ]
        }, index + "-" + text));
}
